import gql from 'graphql-tag';

export const ForgotPassword = gql`
  mutation forgotPassword($email: String, $phoneNumber: String) {
    forgotPassword(email: $email, phoneNumber: $phoneNumber) {
      result
    }
  }
`;

export const ResetPassword = gql`
  mutation resetPassword($token: String!, $password: String!, $phoneNumber: String) {
    resetPassword(token: $token, password: $password, phoneNumber: $phoneNumber)
  }
`;

export const SetPassword = gql`
  mutation setPassword($token: String!, $password: String!, $phoneNumber: String) {
    setPassword(token: $token, password: $password, phoneNumber: $phoneNumber)
  }
`;
